// extracted by mini-css-extract-plugin
export default {"wrapper":"mapActions_wrapper__FVUaQ","button":"mapActions_button__B8lNr"};